/* eslint-disable no-dupe-keys */
import { Box, FormControlLabel, Switch, Grid, Typography, Button, Tooltip, TextField, InputAdornment, FormControl, Select, MenuItem } from '@mui/material'
import React, { useState } from 'react'
import RadioBoxGroup from '../../../components/RadioButtons/RadioBoxGroup'
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import SearchIcon from '@mui/icons-material/Search';
import MemberWorkTimeLimitsTable from './MemberWorkTimeLimitsTable'
import TimerIndividualTable from './TimerIndividualTable'
import MembersTable from './MembersTable'
import AddCustom from '../../../components/Projects/AddCustom';

import ToggleSwitch from '../../../components/ToggleSwitch/ToggleSwitch';

import LockIcon from '@mui/icons-material/Lock';

import LockRoundedIcon from '@mui/icons-material/LockRounded';

import LockOpenRoundedIcon from '@mui/icons-material/LockOpenRounded';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { BorderColor } from '@mui/icons-material';

const roles = [
    { label: 'Never', },
    { label: '5 Mins', },
    { label: '10 Mins', },
    { label: '20 mins', },
    { label: 'Custom', },

];

const inputStyle = {
    height: '40px',
    backgroundColor: '#fff',
    fontSize: '13px',
    BorderColor: '#D0D5DD',
    borderRadius: '8px',
    fontFamily: 'Manrope'
};


const labelStyle = {
    marginBottom: '2px',
    fontWeight: 600,
    color: '#1A1F36',
    fontSize: '14px',
    fontFamily: 'Manrope'
};

const innerParaStyle = {
    marginBottom: '6px',
    fontWeight: 500,
    color: '#1A1F36',
    fontSize: '12px',
    fontFamily: 'Manrope'
}

const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const Members = () => {

    const [role, setRole] = useState('');

    const handleChangeUser = (event) => {
        setRole(event.target.value);
    };

    const [activeTab, setActiveTab] = useState('profileTab');
    const [openAddCustom, setOpenAddCustom] = useState(false);





    const [activeDays, setActiveDays] = useState(['Mon', 'Tue', 'Wed', 'Fri', 'Sat']);

    const toggleDay = (day) => {
        setActiveDays((prev) =>
            prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
        );
    };

    return (
        <>
            <Box sx={{
                overflowX: { xs: 'auto', sm: 'auto', md: 'visible' },
                maxWidth: '100%',
            }}>
                {/* Tabs */}
                <Box display="inline-flex"
                    gap={1}
                    mb={0}
                    sx={{
                        flexWrap: 'nowrap',
                        minWidth: 'max-content',
                    }}>
                    <Button onClick={() => setActiveTab('profileTab')} variant="contained" sx={{
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff',
                        backgroundColor: activeTab === 'profileTab' ? '#0076FE' : '#fff', color: activeTab === 'profileTab' ? '#fff' : '#64748B', border: activeTab === 'profileTab' ? '1px solid #0076FE' : '1px solid #D0D5DD',
                        fontWeight: 600,   fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' },
                        padding: { xl: '8px 16px', lg: '8px 12px', md: '8px 12px', sm: '8px 12px', xs: '8px 16px' }, boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }} >
                        Profile fields</Button>
                    <Button onClick={() => setActiveTab('emailTab')} variant="contained" sx={{
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'emailTab' ? '#0076FE' : '#fff',
                        color: activeTab === 'emailTab' ? '#fff' : '#64748B', border: activeTab === 'emailTab' ? '1px solid #0076FE' : '1px solid #D0D5DD', fontWeight: 600,  fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' },
                        padding: { xl: '8px 16px', lg: '8px 12px', md: '8px 12px', sm: '8px 12px', xs: '8px 16px' },
                        boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }}>Email notifications
                    </Button>

                    <Button onClick={() => setActiveTab('workTab')} variant="contained" sx={{
                        fontFamily: 'Manrope',
                        height: '38px', borderRadius: '100px', backgroundColor: '#fff', backgroundColor: activeTab === 'workTab' ? '#0076FE' : '#fff',
                        color: activeTab === 'workTab' ? '#fff' : '#64748B', border: activeTab === 'workTab' ? '1px solid #0076FE' : '1px solid #D0D5DD', fontWeight: 600,   fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' },
                        padding: { xl: '8px 16px', lg: '8px 12px', md: '8px 12px', sm: '8px 12px', xs: '8px 16px' },
                        boxShadow: 'none', '&:hover': { backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', },
                    }}>Work time & limits
                    </Button>

                </Box>
                {/* Tab Panel Content */}
            </Box>



            <Box sx={{ '& MuiBox-root': { padding: '0' } }}>
                {/* start Profile fields */}
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="profileTab">
                    <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ margin: '16px auto 32px' , flexWrap: 'wrap' }}>
                        <Box sx={{marginBottom: '10px'}}>
                            <Typography sx={{ m: '0 auto 4px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                                Member Profiles
                            </Typography>
                            <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Customize the fields displayed on member profiles by adding or editing them.</Typography>
                        </Box>
                        <Button onClick={() => setOpenAddCustom(true)} variant="contained" sx={{  fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' }, boxShadow: 'none', fontFamily: 'Manrope', height: '38px', borderRadius: '100px', backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', textTransform: 'capitalize' }} >
                            + Add Customs Field</Button>
                    </Box>
                    <MembersTable />
                </CustomTabPanel>
                {/* End Profile fields */}

                {/* start Email notifications */}
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="emailTab">
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ flexWrap: 'wrap' ,  m: '16px auto 32px', p: '14px 12px', border: '1px solid #0076FE', borderRadius: '8px', backgroundColor: '#0076FE0A' }}>
                        <Typography display="flex" alignItems="center" sx={{ marginBottom: '10px' ,  gap: '10px', fontSize: '15px', fontWeight: '500', color: '#0076FE', fontFamily: 'Manrope' }}><img class="img-fluid" alt="Budget Icon" src="./assets/images/app-activity/projects/icons/lock-icon.svg" />
                            This feature can be purchased as part of the Corporate app add-on or by upgrading to the Enterprise plan.</Typography>
                        <Button variant="contained" sx={{     fontSize: { xl: '14px', lg: '12px', md: '12px', sm: '12px', xs: '14px' }, marginBottom: '10px' ,  boxShadow: 'none', fontFamily: 'Manrope', height: '38px', borderRadius: '100px', backgroundColor: '#0076FE', border: '1px solid #0076FE', color: '#fff', textTransform: 'capitalize' }} >
                            View plans & add-ons</Button>
                    </Box>
                    <Box>
                        <Typography display="flex" alignItems="center" sx={{ m: '0 auto 4px', gap: '12px', fontSize: '16px', color: '#A4A4A4', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                            Email notifications
                            <Tooltip title="This setting allows you to automatically assign members to a specific role when creating new projects. Choosing 'None' will disable automatic member assignments." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#A4A4A4', fontWeight: '400', fontFamily: 'Manrope' }}>
                            When creating new accounts, this sets whether the members will receive ANY email communication from timetrackr. This includes notifications about their own work as well as anyone they might manage. This setting can be altered when creating the accounts or individually overridden afterwards in the table below.</Typography>
                    </Box>
                    <Box>
                        <Typography display="flex" alignItems="center" sx={{ m: '32px auto 16px', gap: '12px', fontSize: '16px', color: '#A4A4A4', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                            Default settings
                            <Tooltip title="This setting allows you to automatically assign members to a specific role when creating new projects. Choosing 'None' will disable automatic member assignments." arrow placement="top" alignContent="center">
                                <button className="tooltipBtn ms-2 border-0 bg-transparent p-0">
                                    <InfoOutlineIcon fontSize="small" />
                                </button>
                            </Tooltip>
                        </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Typography sx={{ fontSize: '14px', color: '#A4A4A4', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                            Allow members to receive timetrackr emails.
                        </Typography>
                        <ToggleSwitch />
                    </Box>
                </CustomTabPanel>
                {/* End Email notifications */}
                {/* start Work time & limits */}
                <CustomTabPanel sx={{ '& MuiBox-root': { padding: '0' } }} value={activeTab} index="workTab">
                    <Box sx={{ m: '16px auto 32px' }}>
                        <Typography sx={{ m: '0px auto 4px', fontSize: '16px', color: '#9095A1', fontWeight: '600', fontFamily: 'Manrope', textTransform: 'uppercase', lineHeight: '1' }}>
                            Weekly work days
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>Define the workdays for your team members and indicate which days they cannot log their hours.</Typography>
                    </Box>

                    <Box sx={{ m: '32px auto 24px', paddingBottom: '24px', borderBottom: '1px solid #D0D4E4', }}>
                        <Typography display="flex" alignItems="center" sx={{ gap: '12px',  fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, color: '#1A1F36', fontWeight: '600', fontFamily: 'Manrope', lineHeight: '1' }}>
                            Default settings
                        </Typography>

                        <Box sx={{ m: '20px auto 18px' }}>
                            <Typography sx={{ fontSize: { xl: '15px', lg: '14px', md: '13px', sm: '13px', xs: '13px' }, fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Expected work days: Mon - Fri</Typography>
                            <Box display="flex" flexWrap="wrap" sx={{ gap: '4px', m: '4px auto 0' }}>
                                {days.map((day) => {
                                    const isActive = activeDays.includes(day);
                                    return (
                                        <Button key={day} onClick={() => toggleDay(day)} variant="contained"
                                            sx={{  fontSize: {xl: 14 , lg: 14 , md: 14 , sm: 14 , xs: 14} , 
                                                borderRadius: '30px', backgroundColor: isActive ? '#0076FE' : '#F3F4F6', color: isActive ? '#FFFFFF' : '#606060', textTransform: 'none', px: '16px', py: '6', display: 'flex',
                                                alignItems: 'center', gap: 1, fontWeight: '400', fontFamily: 'Manrope', boxShadow: 'unset', height: '30px', '&:hover': { backgroundColor: isActive ? '#006AE0' : '#D1D5DB', },
                                            }}>
                                            {day}
                                            {isActive ? (
                                                <LockRoundedIcon sx={{ fontSize: {xl: 14 , lg: 14 , md: 14 , sm: 14 , xs: 14} }} />
                                            ) : (
                                                <LockOpenRoundedIcon sx={{ fontSize:  {xl: 16 , lg: 14 , md: 14 , sm: 14 , xs: 14} }} />
                                            )}
                                        </Button>
                                    );
                                })}
                            </Box>
                        </Box>
                        <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ margin: '0 auto 20px' }}>
                            <Typography sx={{ fontSize: { xl: '15px', lg: '14px', md: '13px', sm: '13px', xs: '13px' }, fontWeight: '600', color: '#1A1F36', fontFamily: 'Manrope' }}>Disable time tracking on specific days</Typography>
                            <ToggleSwitch />
                        </Box>

                        <Grid container rowSpacing={1} columnSpacing={5}>
                            <Grid item size={{ xs: 12, md: 6   , lg: 6}}>
                                <Typography variant="body2" sx={labelStyle}>
                                    Expected weekly work hours
                                </Typography>
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography sx={innerParaStyle}>Set expected weekly hours.</Typography>
                                    <Typography component="a" href="#" sx={innerParaStyle} style={{ color: '#0076FE', textDecoration: 'underline' }}>Remove</Typography>
                                </Box>
                                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ gap: '8px' }}>
                                    <TextField
                                        fullWidth
                                        placeholder="No expected hours"
                                        variant="outlined"
                                        InputProps={{ sx: inputStyle }}
                                    />
                                    <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>hrs/wk</Typography>
                                </Box>
                            </Grid>
                            {/* Job Type */}
                            <Grid item size={{ xs: 12, md: 6  , lg: 6}}>
                                <Typography variant="body2" sx={labelStyle}>
                                    Weekly limit
                                </Typography>
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography sx={innerParaStyle}>Set max weekly hours.</Typography>
                                    <Typography component="a" href="#" sx={innerParaStyle} style={{ color: '#0076FE', textDecoration: 'underline' }}>Remove</Typography>
                                </Box>
                                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ gap: '8px' }}>
                                    <TextField
                                        fullWidth
                                        placeholder="No weekly limit"
                                        variant="outlined"
                                        InputProps={{ sx: inputStyle }}
                                    />
                                    <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>hrs/wk</Typography>
                                </Box>
                            </Grid>

                            <Grid item size={{ xs: 12, md: 12  , lg: 12}}>
                                <Typography variant="body2" sx={labelStyle}>
                                    Daily limit
                                </Typography>
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography sx={innerParaStyle}>Set daily hours for members.</Typography>
                                    <Typography component="a" href="#" sx={innerParaStyle} style={{ color: '#0076FE', textDecoration: 'underline' }}>Remove</Typography>
                                </Box>
                                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ gap: '8px' }}>
                                    <TextField
                                        fullWidth
                                        placeholder="No daily limit"
                                        variant="outlined"
                                        InputProps={{ sx: inputStyle }}
                                    />
                                    <Typography sx={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', fontFamily: 'Manrope' }}>hrs/day</Typography>
                                </Box>
                            </Grid>

                            {/* Action Buttons */}
                            <Grid item size={{ xs: 12, md: 12 }} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                                <Button variant="outlined" color="inherit"
                                    sx={{ fontSize: '14px', borderRadius: '50px', background: '#fff', border: '1px solid #9095A1', color: '#9095A1', fontFamily: 'Manrope', textTransform: 'capitalize', fontWeight: '600' }}>Cancel</Button>
                                <Button variant="contained" color="primary" sx={{ fontSize: '14px', borderRadius: '50px', background: '#0076FE', border: '1px solid #0076FE', color: '#fff', fontFamily: 'Manrope', textTransform: 'capitalize', fontWeight: '600' }}>
                                    Save
                                </Button>
                            </Grid>
                        </Grid>

                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ marginBottom: '20px', flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', sx: 'wrap' } }}>
                        <Box sx={{ marginBottom: '10px' }}>
                            <Typography sx={{ fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '16px', xs: '14px' }, fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Individual settings</Typography>
                            <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#9095A1', fontFamily: 'Manrope' }}>Customize settings for selected members instead of using the organization default.</Typography>
                        </Box>
                        <TextField sx={{ width: { xl: 'auto', lg: 'auto', md: 'auto', sm: '100%', xs: '100%' } }}
                            placeholder="Search Member"
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                sx: { marginBottom: '10px', width: '100%', borderRadius: '20px', background: '#fff', fontSize: '13px', minWidth: { xl: '250px', lg: '250px', md: '180px', sm: '180px', xs: '160px' }, fontFamily: 'Manrope' },
                            }}
                        />
                    </Box>
                    <MemberWorkTimeLimitsTable />
                </CustomTabPanel>
                {/* End Work time & limits */}

            </Box>

            <AddCustom open={openAddCustom} onClose={() => setOpenAddCustom(false)} />
        </>
    )
}
const CustomTabPanel = ({ value, index, children }) => {
    if (value !== index) return null;
    return <Box sx={{ padding: { xl: '16px 5px', lg: '15px 0', md: '15px 0', sm: '15px  0', sx: '15px 0' } }}>{children}</Box>;
};


export default Members
